import api from '../lib/axios';
export async function getAgents() {
    const { data } = await api.get('/api/admin/agents');
    return data;
}
/** `existing_account` : l'email appartenait à un citoyen, qui a reçu le rôle d'agent. */
export async function createAgent(body) {
    const { data } = await api.post('/api/admin/agents', body);
    return data;
}
export async function updateAgent(id, body) {
    await api.patch(`/api/admin/agents/${id}`, body);
}
export async function deleteAgent(id) {
    const { data } = await api.delete(`/api/admin/agents/${id}`);
    return data.message;
}
export async function resendAgentInvitation(id) {
    await api.post(`/api/admin/agents/${id}/resend-invitation`);
}
